import clsx from "clsx";
import { HashLink as Link } from "react-router-hash-link";
import styles from "./NavButton.module.scss";

interface Props {
  to: string;
  children: React.ReactNode;
  isActive?: boolean;
}

export function NavButton(props: Props) {
  return (
    <Link
      to={props.to}
      className={clsx(styles.anchorLink, props.isActive && styles.active)}
      smooth
    >
      {props.children}
    </Link>
  );
}
